import { render } from "./NotesTable.vue?vue&type=template&id=1f1ab84a&ts=true"
import script from "./NotesTable.vue?vue&type=script&lang=ts"
export * from "./NotesTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__